// package: kevbox.telemetry.v1
// file: kevbox/telemetry/v1/telemetry_api.proto

var kevbox_telemetry_v1_telemetry_api_pb = require("../../../kevbox/telemetry/v1/telemetry_api_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var TelemetryAPI = (function () {
  function TelemetryAPI() {}
  TelemetryAPI.serviceName = "kevbox.telemetry.v1.TelemetryAPI";
  return TelemetryAPI;
}());

TelemetryAPI.CheckSystemHealth = {
  methodName: "CheckSystemHealth",
  service: TelemetryAPI,
  requestStream: false,
  responseStream: false,
  requestType: kevbox_telemetry_v1_telemetry_api_pb.CheckSystemHealthRequest,
  responseType: kevbox_telemetry_v1_telemetry_api_pb.CheckSystemHealthResponse
};

exports.TelemetryAPI = TelemetryAPI;

function TelemetryAPIClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

TelemetryAPIClient.prototype.checkSystemHealth = function checkSystemHealth(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TelemetryAPI.CheckSystemHealth, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.TelemetryAPIClient = TelemetryAPIClient;

